import React, { useEffect, useState, useCallback } from "react";
import { format } from "date-fns";
import config from "../../config";
import styles from "./PriestMyServices.module.css";
import { getPriestEvents, getPriestProviderEvents } from "../../Apiservices/Auth/servers/fetchProviderData";
import noimage from "../../assets/images/Desktop placeholder.svg";

const PriestMyServices = ({ onEditService }) => {
  const [loading, setLoading] = useState(true);
  const [savedCategories, setSavedCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchSavedServices = useCallback(async () => {
    setLoading(true);
    try {
      const priestEventMaster = await getPriestEvents();
      const priesAddedServices = await getPriestProviderEvents();

      console.log("Master Events:", priestEventMaster);
      console.log("Added Services:", priesAddedServices);

      const transformedData = [];

      if (Array.isArray(priestEventMaster) && Array.isArray(priesAddedServices)) {
        priestEventMaster.forEach((category) => {
          const categoryEvents = [];

          category.events.forEach((event) => {
            // Find if this event is mapped by the provider
            const existingCategory = priesAddedServices.find(
              (mapped) => mapped.categoryId === category.id
            );

            if (existingCategory) {
              const mappedEvent = existingCategory.events.find(
                (e) => e.eventId === event.id
              );

              // A service is saved if it has a price
              if (mappedEvent && mappedEvent.price) {
                categoryEvents.push({
                  id: event.id,
                  name: event.name,
                  imageid: event.image_id,
                  price: mappedEvent.price,
                  discountPrice: mappedEvent.discountPrice,
                  discountValidUpto: mappedEvent.discountValidUpto,
                  categoryId: category.id,
                });
              }
            }
          });

          if (categoryEvents.length > 0) {
            transformedData.push({
              id: category.id,
              categoryName: category.name,
              events: categoryEvents,
            });
          }
        });
      }

      setSavedCategories(transformedData);
    } catch (error) {
      console.error("Failed to fetch saved services:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSavedServices();
  }, [fetchSavedServices]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    try {
      return format(new Date(dateStr), "d MMM yy");
    } catch (e) {
      return dateStr;
    }
  };

  const getFilteredCategories = () => {
    if (!searchTerm.trim()) return savedCategories;

    return savedCategories
      .map((cat) => {
        const filteredEvents = cat.events.filter((e) =>
          e.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        return { ...cat, events: filteredEvents };
      })
      .filter((cat) => cat.events.length > 0);
  };

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <i className="pi pi-spin pi-spinner" style={{ fontSize: "2rem", color: "#0cc0df" }}></i>
        <p>Loading your saved services...</p>
      </div>
    );
  }

  const filteredCategories = getFilteredCategories();

  return (
    <div className={styles.pageContainer}>
      <div className={styles.searchBox}>
        <i className={`pi pi-search ${styles.searchIcon}`}></i>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search events"
          className={styles.searchInput}
        />
      </div>

      {filteredCategories.length > 0 ? (
        filteredCategories.map((category) => (
          <div key={category.id} className={styles.categorySection}>
            <h2 className={styles.categoryTitle}>{category.categoryName}</h2>
            <div className={styles.cardsGrid}>
              {category.events.map((event) => (
                <div key={event.id} className={styles.card}>
                  <div className={styles.cardLeft}>
                    {event.imageid ? (
                      <img
                        src={`${config.API_BASE_URL}/gallery/download/${event.imageid}`}
                        alt={event.name}
                        className={styles.cardImage}
                        onError={(e) => {
                          e.target.src = noimage;
                        }}
                      />
                    ) : (
                      <img
                        src={noimage}
                        alt={event.name}
                        className={styles.cardImage}
                      />
                    )}
                  </div>

                  <div className={styles.cardMiddle}>
                    <h3 className={styles.cardTitle}>{event.name}</h3>

                    <div className={styles.pricePillContainer}>
                      <div className={styles.pricePill}>
                        {event.discountPrice ? (
                          <>
                            <span className={styles.originalPrice}>₹{event.price}</span>
                            <span className={styles.discountPrice}>₹{event.discountPrice}</span>
                          </>
                        ) : (
                          <span className={styles.discountPrice}>₹{event.price}</span>
                        )}
                      </div>
                    </div>

                    {event.discountPrice && event.discountValidUpto && (
                      <span className={styles.validityDate}>
                        Valid {formatDate(event.discountValidUpto)}
                      </span>
                    )}
                  </div>

                  <div className={styles.cardRight}>
                    <button
                      type="button"
                      className={styles.editButton}
                      onClick={() => onEditService(event.categoryId)}
                      title="Edit Service"
                    >
                      <i className="pi pi-pencil"></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))
      ) : (
        <div className={styles.noServices}>
          <p>{searchTerm ? "No matching services found." : "You have not saved any services yet."}</p>
        </div>
      )}
    </div>
  );
};

export default PriestMyServices;
